/**
 * @namespace helpers
 */

/**
 * Helper functions for Date
 *
 * @module date
 * @memberof helpers
 * @see helpers
 */

import moment from 'moment'

/**
 * stringToDate for time
 *
 * @function
 * @param  {string} utcStr
 * @param  {string} mode
 * @return {Date} time
 */
export const timeStringToDate = (utcStr, mode = 'no') => {
  const time = new Date()
  if (utcStr) {
    const timezoneOffset = parseInt(window.localStorage.getItem('timezoneOffset'))
    const hours = utcStr ? +utcStr.split(':')[0] : 0
    const minutes = utcStr ? +utcStr.split(':')[1] : 0
    const seconds = (utcStr && utcStr.split(':').length > 2) ? +utcStr.split(':')[2] : 0
    time.setHours(hours + timezoneOffset)
    time.setMinutes(minutes)
    time.setSeconds(seconds)
  } else {
    switch (mode) {
      case 'startOfDay' :
        time.setHours(0)
        time.setMinutes(0)
        time.setSeconds(0)
        break
      case 'endOfDay':
        time.setHours(23)
        time.setMinutes(59)
        time.setSeconds(0)
        break
    }
  }
  return time
}

/**
 * format Date by timezone for time
 *
 * @function
 * @param  {number} datems
 * @param toUtc
 * @return {any} date
 */
export const formatDateByTimezone = (datems, toUtc = true) => {
  const date = moment(datems)
  const browserOffset = parseInt(moment().tz(Intl.DateTimeFormat().resolvedOptions().timeZone).format('Z'))
  const timezoneOffset = parseInt(window.localStorage.getItem('timezoneOffset'))
  if (toUtc) {
    return date.add(browserOffset - timezoneOffset, 'hours').utc()
  } else {
    return date.add(timezoneOffset - browserOffset, 'hours')
  }
}
/**
 * format Date without utc
 *
 * @function
 * @param  {Date} date
 * @param {string} format
 * @return {any} date
 */
export const dateAsUTC = (date, format) => {
  if (date) {
    return moment.utc(`${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}`).format(format)
  }
  return ''
}
